// §4 "Mobile behavior": office screens are responsive READ-ONLY on a phone —
// transitions disabled below `md`. The CSS removes `.wo-transitions` visually;
// this hook is the JS half for controls the CSS cannot express (S4's drag
// affordance, a shared EmptyState CTA). 769px matches production.css's 768px
// collapse breakpoint exactly.

import { useEffect, useState } from "react";

const QUERY = "(min-width: 769px)";

export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState<boolean>(() =>
    typeof window.matchMedia === "function" ? window.matchMedia(QUERY).matches : true,
  );

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return undefined;
    const media = window.matchMedia(QUERY);
    const onChange = (event: MediaQueryListEvent) => {
      setIsDesktop(event.matches);
    };
    media.addEventListener("change", onChange);
    return () => {
      media.removeEventListener("change", onChange);
    };
  }, []);

  return isDesktop;
}
